var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShoppingCardSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#B4CCB9",
    cx: 46,
    cy: 58,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B4CCB9",
    cx: 20.09,
    cy: 58,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4CCB9",
    d: "M10,3C9.837,2.455,9.386,2,8.833,2H3C2.447,2,2,2.447,2,3s0.447,1,1,1c0,0,3.833,0,4.529,0 S8.38,4.611,8.38,4.611l2.814,11.965C11.762,16.209,12.526,16,13.518,16h-0.459L10,3z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F76D57",
    d: "M61.974,20l-6,26c-0.271,1.166-1.021,2-2.125,2H20.131c-1.102,0-1.85-0.834-2.12-2l-5.988-26 c-0.312-1.23,0.125-2,1.479-2h46.989C61.849,18,62.286,18.77,61.974,20z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#394240",
    cx: 46,
    cy: 58,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#394240",
    cx: 20.09,
    cy: 58,
    r: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M60.476,16H15.059L12,3c-0.438-1.75-1.614-3-3.271-3H3C1.343,0,0,1.342,0,3c0,1.656,1.343,3,3,3h3.723 l3.371,14l7.698,32.457C15.619,53.359,14.09,55.5,14.09,58c0,3.312,2.687,6,6,6c2.972,0,5.433-2.162,5.91-5h14.09 c0.478,2.838,2.938,5,5.91,5c3.313,0,6-2.688,6-6c0-3.314-2.687-6-6-6c-2.972,0-5.433,2.164-5.91,5H26 c-0.478-2.836-2.938-5-5.91-5c-0.125,0-0.246,0.012-0.369,0.018l-0.642-2.258c0.428,0.145,0.893,0.24,1.426,0.24h32.969 c2.625,0,3.908-1.904,4.5-4l5.933-26C64.344,17.582,63.265,16,60.476,16z M46,54c2.209,0,4,1.791,4,4s-1.791,4-4,4s-4-1.791-4-4 S43.791,54,46,54z M8.38,4.611C8.38,4.611,8.226,4,7.529,4S3,4,3,4C2.447,4,2,3.553,2,3s0.447-1,1-1h5.833 C9.386,2,9.837,2.455,10,3l3.059,13h0.459c-0.991,0-1.756,0.209-2.323,0.576L8.38,4.611z M20.09,54c2.209,0,4,1.791,4,4 s-1.791,4-4,4s-4-1.791-4-4S17.881,54,20.09,54z M61.974,20l-6,26c-0.271,1.166-1.021,2-2.125,2H20.131 c-1.102,0-1.85-0.834-2.12-2l-5.988-26c-0.312-1.23,0.125-2,1.479-2h46.989C61.849,18,62.286,18.77,61.974,20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M37,22c-1.657,0-3,1.342-3,3v16c0,1.656,1.343,3,3,3s3-1.344,3-3V25C40,23.342,38.657,22,37,22z M38,41 c0,0.553-0.447,1-1,1s-1-0.447-1-1V25c0-0.553,0.447-1,1-1s1,0.447,1,1V41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M47,22c-1.657,0-3,1.342-3,3v16c0,1.656,1.343,3,3,3s3-1.344,3-3V25C50,23.342,48.657,22,47,22z M48,41 c0,0.553-0.447,1-1,1s-1-0.447-1-1V25c0-0.553,0.447-1,1-1s1,0.447,1,1V41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M27,22c-1.657,0-3,1.342-3,3v16c0,1.656,1.343,3,3,3s3-1.344,3-3V25C30,23.342,28.657,22,27,22z M28,41 c0,0.553-0.447,1-1,1s-1-0.447-1-1V25c0-0.553,0.447-1,1-1s1,0.447,1,1V41z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M47,24c-0.553,0-1,0.447-1,1v16c0,0.553,0.447,1,1,1s1-0.447,1-1V25C48,24.447,47.553,24,47,24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M37,24c-0.553,0-1,0.447-1,1v16c0,0.553,0.447,1,1,1s1-0.447,1-1V25C38,24.447,37.553,24,37,24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M27,24c-0.553,0-1,0.447-1,1v16c0,0.553,0.447,1,1,1s1-0.447,1-1V25C28,24.447,27.553,24,27,24z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCardSvgrepoCom);
export default __webpack_public_path__ + "static/media/shopping-card-svgrepo-com.54037bd02d8c2983589abba70fe10c9f.svg";
export { ForwardRef as ReactComponent };